// The Monitor's look (Session Control's cards, the toolbar buttons beside its tabs), shared
// so pages that sit next to it - the experiment page - look like it.

// A tab's body: grey background, cards stacked with a gap.
export const dashboardPage = {
  display: 'flex',
  flexDirection: 'column',
  gap: '20px',
  padding: '20px',
  height: '100%',
  backgroundColor: '#f3f4f6',
}

export const card = {
  background: 'white',
  borderRadius: '12px',
  padding: '24px 28px',
  border: '1px solid #e5e7eb',
}

export const cardHeader = {
  display: 'flex',
  alignItems: 'center',
  gap: '10px',
  marginBottom: '4px',
}

export const cardTitle = {
  fontSize: '17px',
  fontWeight: 700,
  color: '#111',
  margin: 0,
}

export const cardSubtitle = {
  fontSize: '13px',
  color: '#9ca3af',
  margin: '0 0 20px 0',
}

// The small white buttons next to the Monitor's tabs ("Open Workspace", "Refetch").
export const toolbarButton = {
  display: 'flex',
  alignItems: 'center',
  gap: '6px',
  padding: '6px 14px',
  borderRadius: '8px',
  border: '1px solid #d1d5db',
  background: 'white',
  fontSize: '12px',
  fontWeight: 500,
  color: '#555',
  cursor: 'pointer',
}
